import { useEffect, useRef, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";

export default function Toggle (props: {type?: "button" | "checkbox", id: string, value: boolean, info_title?: string, info_text?: string, icon:string, icon_active?:string, onBlur?: ()=> void, onChange: (value: boolean) => void,  label: string, count?: number}){
  const ref = useRef<HTMLDivElement>(null);
  const setLastToggleRef = useQuestionizerStore((state) => state.setLastToggleRef);
  const useLabels = useQuestionizerStore((state) => state.config?.use_labels);
  const svg_mode = useQuestionizerStore((state) => state.config?.svg_mode);
  const show_count = (props.count !== undefined && props.count > 0);
  const icon_url = (props.value || props.icon_active === undefined) ? `url(${props.icon_active})` : `url(${props.icon})`;
  
  const [svg_icon, set_svg_icon] = useState<string>('');
  
  const icon_type : "svg" | "png" | "fontawesome" = (props.icon?.endsWith(".svg") && svg_mode == "inline_svg") ? "svg" : ((props.icon?.endsWith(".png") || (props.icon?.endsWith(".svg") && svg_mode == "background")) ? "png" : "fontawesome")

  useEffect(()=>{
    async function fetch_icon(){
      const response = await fetch(props.icon);
      const svg_text = await response.text();
      set_svg_icon(svg_text.replace('<?xml version="1.0" encoding="UTF-8"?>', ''));
    }
    if(icon_type == "svg"){
      fetch_icon();
    }
  },[]);

  return <div 
          ref={ref}
          role={ props.type ? props.type : "checkbox" }
          aria-checked={props.value || false} 
          aria-label={props.label + ' ' + (show_count ? (props.count + " Unterpunkte aktiviert") : '') + ' ' + (props.info_title ?? '') + ' ' + (props.info_text ?? '')}
          aria-describedby={props.id + "-description"}
          tabIndex={0}
          className={"toggle input-"+props.id} 
          onClick={()=>{
            props.onChange(!props.value);
            setLastToggleRef(ref);
          }}
          onBlur={props.onBlur}
          onKeyDown={(event)=>{
            if ((event.key != "Enter") && (event.key != " ")){ return; }
			      event.stopPropagation();
            props.onChange(!props.value);
            setLastToggleRef(ref);
          }}
          >
          {show_count && 
            <div role="presentation" className="toggle-bubble">
              {props.count}
            </div>
          }
		  
          {icon_type == "fontawesome" && 
            <i role="presentation" className="fa-duotone fa-solid fa-heat"></i>
          }
          {icon_type == "svg" && svg_icon && <div role="presentation" aria-hidden className={"toggle__svg_img "  + (props.value ? "toggle__img--active " : "")} dangerouslySetInnerHTML={{__html:svg_icon}} />}
          {icon_type == "png" && !svg_icon && <div role="presentation" aria-hidden className={"toggle__img " + (props.value ? "toggle__img--active " : "") + (show_count ? "toggle__img--has-count " : "")} style={{backgroundImage: icon_url}}></div>}
  
          {useLabels && <label role="presentation" aria-hidden className='toggle__label'>{props.label}</label>}
          <div id={props.id + "-description"} className="toggle__infos">
            {props.info_title && <p className="font-bold mb-3">{props.info_title}</p>}
            {props.info_text && <p className="">{props.info_text}</p>}
          </div>
          
        </div>
}

